import axios from 'axios'
import { UserModel} from './_models'
import {BASEURL} from '../../../../axios/services'
import {postApi} from '../../../../axios'
import {encryptPayloadPasswords} from '../../../../utils/passwordEncryption'

const API_URL = BASEURL

export const GET_USER_BY_ACCESS_TOKEN_URL = `${API_URL}verify_token`
export const LOGIN_URL = `${API_URL}coms/signin/`
export const REGISTER_URL = `${API_URL}coms/signup/`
export const RESET_PASSWORD = `${API_URL}resetpassword/`
export const SET_NEW_PASSWORD = `${API_URL}set-new-password/`
export const VERIFY_OTP = `${API_URL}verifyotp/`



// Other imports...

interface ApiResponse {
  success: boolean;
  error: boolean;
  status: number;
  message: string;
  data:string;
}

// Server should return AuthModel
export async function login(email: string, password: string) {
  const payload = await encryptPayloadPasswords({
    username: email,
    password,
  })
  return axios.post(LOGIN_URL, payload)
}

// Server should return AuthModel
export async function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string,
  user_role: string,
  phone_number?: string
) {
  const payload = await encryptPayloadPasswords({
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
    user_role,
    phone_number,
  })
  return axios.post(REGISTER_URL, payload)
}

// Server should return object => { result: boolean } (Is Email in DB)
// export function requestPassword(email: string) {
//   return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
//     email,
//   })
// }

export function requestPassword(data: { username: string }) {
  return axios.post<ApiResponse>(RESET_PASSWORD, data)
}


export function verifyResetOtp(data: {
  mail: string
  otp: string
  filetype: string
}) {
  return axios.post<ApiResponse>(VERIFY_OTP, data)
}

export async function resetPassword(data: {
  userEmail: string
  password: string
}) {
  const payload = await encryptPayloadPasswords({
    userEmail: data.userEmail,
    password: data.password,
  })

  return axios.patch<ApiResponse>(SET_NEW_PASSWORD, payload)
}

// export function getUserByToken(token: string) {
//   return axios.post<UserModel>(GET_USER_BY_ACCESS_TOKEN_URL, {
//     api_token: token,
//   })
// }


export function getUserByToken() {
  return postApi('verify_token', {}) as Promise<{data: UserModel}>
}
